<section class="hero-area hero-v3 bg-contain bg-tuna">
    <div class="container">
        <div class="row align-items-end">
            <div class="col-lg-7">
                <div class="hero-content">
                    <div class="section-title section-title-white">
                        <h1 class="wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="2500ms" style="margin-bottom: 5px">Polypharm Solutions</h1>
                        <div class="section-title-quote wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="1500ms">
                            <p>Changing the way we choose medications</p>
                        </div>
                        <div class="section-button-wrapper section-dual-button wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="2500ms">
                            <a href="https://app.polypharm.solutions" target="_blank" class="filled-btn bg-rose-bud">
                                Try now <i class="fab fa-chrome"></i>
                            </a>
                            <a href="https://scribehow.com/shared/Polypharm_Workflow__jOS-1ZauSSKt_owU8D031g"
                               target="_blank"
                               class="filled-btn btn-bordered">
                                User guide <i class="fab fa-readme"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 align-self-center">
                <div class="hero-right-image-wrapper text-center">
                        <img class="particle-1 animate-rotate-me"
                             src="assets/img/logo/polypharm-icon-transparent.png"
                             style="max-width: 50%"
                             alt="Polypharm-icon">
                </div>
            </div>
        </div> <!-- /.row -->
    </div> <!-- .container -->
</section>
